import DASHBOARD from "./Dashboard";

const CORPORATE_AND_INDIVIDUAL_PAGES = {
  DASHBOARD,
};

export default CORPORATE_AND_INDIVIDUAL_PAGES;
